import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";
import { LinkFragment } from "../fragments/LinkFragment";

export const CurveCarouselSectionById = graphql(
  `
    query CurveCarouselSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      curveCarouselSection(id: $id, preview: $preview, locale: $locale) {
        ...CurveCarouselSectionFragment
      }
    }

    fragment CurveCarouselSectionFragment on CurveCarouselSection {
      accessibilityControlLabelPrevious
      accessibilityControlLabelNext
      itemsCollection(limit: 15) {
        items {
          image {
            url
            title
          }
          icon {
            url
            title
          }
          itemDescription
          highlightTheme {
            palette
            foreground
            background
          }
          sourceInfo {
            ...RichTextFragment
          }
        }
      }
      ctaLink {
        ...LinkFragment
      }
    }
  `,
  [RichTextFragment, LinkFragment]
);
